module.exports = __webpack_public_path__ + "static/media/default_country.cfd88ac9.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/Defaults/default_country.jpg
// module id = 1122
// module chunks = 0